import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

function ProfilesCollapseModal({ type, isOpen, user, intl, messages, onClose, onContinue }) {
  if (type === 'profile-created') {
    return (
      <Modal
        show={isOpen}
        onClose={onClose}
        buttons={[
          {
            label: intl.formatMessage(messages.continue),
            style: { fontWeight: 600 },
            onClick: onContinue,
          },
        ]}
        small
      >
        <i className="icon ti-thumb-up"></i>
        <h5 className="modal-title">{intl.formatMessage(messages.profileCreatedTitle)}</h5>
        <div
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(messages.profileCreatedMessage, { name: user.name }),
          }}
        />
      </Modal>
    );
  }

  if (type === 'profile-remove') {
    return (
      <Modal
        show={isOpen}
        onClose={onClose}
        buttons={[
          {
            label: intl.formatMessage(messages.cancel),
            style: { fontWeight: 600 },
            onClick: onClose,
          },
          {
            label: intl.formatMessage(messages.continue),
            style: { fontWeight: 600 },
            onClick: () => onContinue(),
          },
        ]}
      >
        <i className="icon pe-7s-close-circle"></i>
        <h5 className="modal-title">{intl.formatMessage(messages.profileCancelTitle)}</h5>
        <div
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(messages.profileCancelMessage),
          }}
        />
      </Modal>
    );
  }

  return null;
}

export default injectIntl(ProfilesCollapseModal);
